<template>
  <auth-template>
    <b-col md="5">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
            <b-form>
              <h1>Redirecionando...</h1>
            </b-form>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-col>
  </auth-template>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import SessionStorage from '@/services/session-storage'

export default {
  name: 'Login',
  components: {
    AuthTemplate
  },
  data () {
    return {
    }
  },
  mounted () {
    this.callback(this.$route.params.token)
  },
  methods: {
    callback (token) {
      let dados = { token: token }

      Vue.http.post('api/auth/cliente', dados).then(response => {
        SessionStorage.set('token', response.body.data[0].token)
        SessionStorage.set('perfil', response.body.data[0].perfil_id)
        SessionStorage.set('usuario', response.body.data[0].user)
        SessionStorage.set('singleAcess', response.body.data[0].singleAcess)
        SessionStorage.setObject('permissoes', response.body.data[0].permissoes[0][0].permissoes)
        
        let barra = '/'

        if (this.$route.params.rota_desejada) {
         
          let route = this.$route.params.rota_desejada.split('5567')

         console.log('/formulario-integracao/' + route[1] + '/' + this.$route.params.id_vinculo)
         console.log(route[1])
         console.log(this.$route.params.id_vinculo)
    
          if(route[0] == "formulario"){
            switch (route[1]) {
              case 'visualizar':             
                this.$router.push('/formulario-integracao/' + route[1] + '/' + route[2])
                break;  
              case 'encaminhar':             
                this.$router.push('/formulario-integracao/' + route[1] + '/' + route[2])
                break; 
              case 'respostas':             
                this.$router.push('/formulario-integracao/' + route[1] + '/' + route[2])
              break; 
              case 'visualizarImpressao':             
                this.$router.push('/formulario-integracao/' + route[1] + '/' + route[2])
              break; 
              case 'visualizarResposta':             
                this.$router.push('/formulario-integracao/resposta/visualizar/' + route[2])
              break; 
              case 'visualizarEstrutura':             
                this.$router.push('/formulario-integracao/visualizar/estrutura/' + route[2])
                break;             
              case 'editar':
                this.$router.push('/formulario-integracao/' + route[1] + barra + this.$route.params.id_vinculo)
                break;
              case 'duplicar':
                this.$router.push('/formulario-integracao/' + route[1] + barra + this.$route.params.id_vinculo.replaceAll('abc', '/'))
                break;
              case 'cadastrar':
                this.$router.push('/formulario-integracao/' + route[1] + barra + this.$route.params.id_vinculo)
                break;          
            }
          }else{
            this.$router.push('/formulario-integracao/visualizar/00')
          }         
        }

        if (this.$route.params.id_vinculo) {
          route = route + '/' + this.$route.params.id_vinculo
        }

        this.$router.push(route)

        return true
      }).catch(e => {})
    }
  }
}
</script>

<style scoped>
.recaptchaBox {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/RedirectCliente.vue